module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAPCAYAAADZCo4zAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABYSURBVBiVvdC7DYAwFEPRI2WBjJBRGImSjlEYgRmYgBEySmhS5iMoeJ3lK+vZARkRl8YFJGxVNyE4UbD3gIj7PyjVZgVrD1oqUF4nDH/4bpotecx655H5AKseIC1erp00AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right.png
// module id = vC+O
// module chunks = 1